import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccessListComponent } from './list/access-list.component';
import { AccessViewComponent } from './view/access-view.component';
import { AccessEditComponent } from './edit/access-edit.component';
import { AccessNewComponent } from './new/access-new.component';
import { AccessComponent } from './access.component';
import { NgModule } from '@angular/core';
import { AccessRoutingModule,ROUTABLE_COMPONENTS } from './access.routing';
import { MatTableModule,MatSelectModule} from '@angular/material';
import { AccessService } from './shared/access.service';
import { MatButtonModule, MatInputModule, MatCheckboxModule,MatSlideToggleModule,MatPaginatorModule } from '@angular/material';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { SidebarModule } from '../../../shared/sidebar/sidebar.module';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';

@NgModule({
    imports: [
      BrowserModule,
      MatTableModule,
      AccessRoutingModule,
      MatCheckboxModule, MatButtonModule, MatInputModule, MatPaginatorModule,
      FormsModule, ReactiveFormsModule,
      FabButtonGroupModule,MatSelectModule,
      SectionBarModule, MatSlideToggleModule,
      TitlebarModule, HeaderModule, LoaderModule, SnackbarModule, SidebarModule,
      GridEmptyModule
    ],
    entryComponents: [],
    exports: [],
    declarations: [
        AccessListComponent,
        AccessViewComponent,
        AccessEditComponent,
        AccessNewComponent,
        AccessComponent,
        ROUTABLE_COMPONENTS
    ],
    providers: [AccessService],
    bootstrap: []
})
export class AccessModule {
}
